import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTruliaComponent } from './simple-icons-trulia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTruliaComponent ],
    exports:      [ SimpleIconsTruliaComponent ],
    bootstrap:    []
})
export class SimpleIconsTruliaModule {}
